import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getRoles, login } from '@schaeffler/azure-auth';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

import { getProfileImage, getUsername } from '@schaeffler/azure-auth';

@Component({
  selector: 'na-roll-mapping-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'Mapping Tool';
  _userUniqueId!: string;
  _userRoles!: string[];
  _isAdmin!: boolean;
  isCementMiningOpen = false;


  public username$!: Observable<string>;
  public profileImage$!: Observable<string>;

  public constructor(private readonly store: Store, private readonly router: Router) {}

  public ngOnInit(): void {
    this.username$ = this.store.select(getUsername);
    this.profileImage$ = this.store.select(getProfileImage);

    this.store
      .pipe(
        getRoles
      )
      .subscribe(value => {
        this._userRoles = value;
        this._isAdmin = this._userRoles.includes('Admin');
      });

    if (this.username$ == undefined || this.username$ == null) {
      this.store.dispatch(login());
    }

    this.isCementMiningOpen = this.isCementMiningRoute(this.router.url);

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd)
      )
      .subscribe((event) => {
        const navigationEnd = event as NavigationEnd;
        this.isCementMiningOpen =
          this.isCementMiningRoute(navigationEnd.urlAfterRedirects);
      });    
  }

 toggleCementMining(): void {
    this.isCementMiningOpen = !this.isCementMiningOpen;
  }

  private isCementMiningRoute(url: string): boolean {
    return url.startsWith('/cement-mining');
  }  

  triggerEscapeKey(): void {
    const event = new KeyboardEvent("keyup",{
      key: 'Escape',
      code: 'Escape',
      keyCode: 27,
      bubbles: true
      });
    document.dispatchEvent(event);
  }
}

